import { RecipientCreateRequest, RecipientCreateResponse } from './recipient-domain';

export abstract class RecipientRepository {

  abstract createRecipient(data: RecipientCreateRequest): Promise<RecipientCreateResponse>;
}
